import { render, staticRenderFns } from "./CustomLink.vue?vue&type=template&id=22c26eec&scoped=true"
import script from "./CustomLink.vue?vue&type=script&lang=js"
export * from "./CustomLink.vue?vue&type=script&lang=js"
import style0 from "./CustomLink.vue?vue&type=style&index=0&id=22c26eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c26eec",
  null
  
)

export default component.exports